import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarProfileComponent } from './avatar-profile.component';

const components = [AvatarProfileComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...components],
    exports: [...components]
})
export class AvatarProfileModule {}
